/** Routes accessible without authentication (no GameContext login redirect). */
export const PUBLIC_ROUTES = [
  '/login',
  '/register',
  '/onboard',
  '/forgot-password',
  '/reset-password',
  '/sms-opt-in',
  '/privacy',
  '/terms',
  '/show-us-your-tds',
];

export const isPublicRoute = (pathname) =>
  PUBLIC_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
